/* 🤖 this file was generated by svg-to-ts */
export const matIconIncompleteCircle: {
  name: 'incomplete-circle';
  data: string;
} = {
  name: 'incomplete-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-2.76 1.12-5.26 2.93-7.07L12 12V2c5.52 0 10 4.48 10 10z"/></svg>`
};
